import nativeBridge from '@ifit/native-webview-interface';
import once from 'lodash.once';
import { libraryPageTitle, searchText } from '../i18n/translations';
import getStore from '../store';
import { getCurrentPoint, getCurrentLocation } from '../store/selectors';

// toolbar title
export let lastTitle;
// free users header button
let lastShowButtonArgs = null;

function showHamburger() {
  const store = getStore();
  const state = store.getState();
  const challengesRoute = '/challenges';
  const { entryPoint } = state.config;
  const { pathname: currentPage } = getCurrentLocation(state);
  const currentPoint = getCurrentPoint(state);
  return (
    currentPage === '/' ||
    (entryPoint === challengesRoute && currentPoint === entryPoint)
  );
}

export const generateToolbarPayload = title => {
  return {
    methodName: 'SetToolbarTitle',
    title,
    buttonStyle:
      title === libraryPageTitle() || showHamburger() ? 'hamburger' : 'back',
    searchIsVisible: false,
    showHeaderShadow: title !== searchText(),
  };
};

export function enableSearch() {
  return;
}

export function disableSearch() {
  return;
}

export function setLastTitle(title) {
  lastTitle = title;
}

export function setToolbarTitle(title) {
  setLastTitle(title);
  nativeBridge.callNative(generateToolbarPayload(title));
}

export function showButton(registerButtonIsVisible, registerButtonText) {
  const showButtonArgs = Array.prototype.slice.call(arguments).join('');
  if (showButtonArgs !== lastShowButtonArgs) {
    lastShowButtonArgs = showButtonArgs;
    nativeBridge.callNative({
      methodName: 'SetToolbarTitle',
      registerButtonIsVisible,
      registerButtonText,
    });
  }
}

export const notifyTimeToInteractive = once(() =>
  nativeBridge.callNative({
    methodName: 'TimeToInteractive',
  }),
);

export function upgradeUser() {
  nativeBridge.callNative({
    methodName: 'NavigateToPayment',
  });
}

export function notifyTrackingEvent(event, properties) {
  nativeBridge.callNative({
    methodName: 'TrackingEvent',
    event,
    properties,
  });
}

export function hideModality() {
  nativeBridge.callNative({ methodName: 'hideModality' });
}

export function showModality() {
  nativeBridge.callNative({ methodName: 'showModality' });
}
